import { useState } from "react";
import React from "react";
import ApiContext from "./api-context";
function ApiProvider(props) {
  const routesInfo = [
    { name: "bagni", link: "bagnis" },
    { name: "lavanderia", link: "lavanderias" },
    { name: "lavabi", link: "lavabis" },
    { name: "piani", link: "pianis" },
    { name: "specchi", link: "specchis" },
    { name: "lampade", link: "lampades" },
    { name: "miscelatori", link: "miscelatoris" },
    { name: "doccia", link: "doccias" },
  ];

  return (
    <ApiContext.Provider value={routesInfo}>
      {props.children}
    </ApiContext.Provider>
  );
}

export default ApiProvider;
